import {createReducer} from '@reduxjs/toolkit'
import {
  dHRecordSetDataAC,
  dHRecordSetFiltersAC,
  dHRecordClearFiltersAC,
  dHRecordSetPageNumberAC,
  dHRecordSetPaginationAC,
  dHRecordSetDetailItemAC, dHRecordSetItemsForPageAC
} from './dHandoverRecordActionCreators'
import {typePagination} from 'model/system/constants'
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';

//Types

export type IdHandoverRecordStateDataItem = {
  checked: boolean,
  cashierId: string,
  cashierName: string,
  closeDate: string,
  id: string,
  openDate: string,
  pos: {
    id: string,
    fiscalCardId: string,
    posHardwareModel: string,
    posHardwareSerialNumber: string,
    posNumber: number,
    store: {
      id: string,
      name: string,
      address: string,
      phoneNumber: string,
      email: string,
      manager: string,
      managerPhoneNumber: string,
      description: string,
      deleted: boolean
    }
  },
  refundsAmount: number,
  refundsCount: number,
  refundsWithCards: number,
  refundsWithCash: number,
  refundsWithCashless: number,

  salesAmount: number,
  salesCount: number,
  salesWithCards: number,
  salesWithCash: number,
  salesWithCashless: number,

  userId: string,
  userName: string
}

export type typeHandoverRecordFilters = {
  posNumber?: string | null,
storeName?: string | null,

  userName?: string | null,
  closeDate?: {
    from: string | null,
    to: string | null,
  } | null,
}

export const cleanFilterObject: typeHandoverRecordFilters = {
  posNumber: '',
  storeName: null,

  userName:  '',
  closeDate: {from: null, to: null},
}

export type IdHandoverRecordsState =  {
  pagination: typePagination,
  data: IdHandoverRecordStateDataItem[],
  detailItem: IdHandoverRecordStateDataItem | undefined,
  filters: typeHandoverRecordFilters
}

// Init state
export const initialState: IdHandoverRecordsState = {
  pagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
  data: [],
  detailItem: undefined,
  filters: cleanFilterObject
};

// Reducer
export const DHandoverRecordReducer = createReducer(initialState, builder => {builder


  // Reducer of clear filtersForm
  .addCase(dHRecordClearFiltersAC, (state) => {
    state.filters = cleanFilterObject
  })

  // Reducer of set filtersForm
  .addCase(dHRecordSetFiltersAC, (state, action) => {
    state.filters = {...state.filters, ...action.payload}
    state.pagination.pageNumber = 0
  })

  // Reducer of set pagination
  .addCase(dHRecordSetPaginationAC, (state, action) => {
    state.pagination = {...state.pagination, ...action.payload.pagination}
  })

    // Reducer of set items for page pagination
    .addCase(dHRecordSetItemsForPageAC, (state, action) => {
      state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
    })

  // Reducer of set pageNumber pagination
  .addCase(dHRecordSetPageNumberAC, (state, action) => {
    state.pagination.pageNumber = action.payload.pageNumber
  })


  // Reducer of set data
  .addCase(dHRecordSetDataAC, (state, action) => {
    state.data = action.payload
  })



  // Reducer of set detail item
  .addCase(dHRecordSetDetailItemAC, (state, action) => {
    state.detailItem = state.data.find((item) => item.id === action.payload)
  })

  // Reducer of clear state
  .addCase(logoutAC, ( state ) => {
    state.data = initialState.data
    state.detailItem=initialState.detailItem
    state.filters = initialState.filters
    state.pagination = initialState.pagination
  })

  .addCase(resetReducers, (state, action) => {
    if (action.payload !== "handover-record") {
      state.data = initialState.data
      state.detailItem=initialState.detailItem
      state.filters = initialState.filters
      state.pagination = initialState.pagination
    }
  });
})

